import { Button, Carousel, Empty, Image, Spin } from "antd";

import { useCallback, useEffect, useMemo, useRef, useState } from "react";

import "./index.less";
import { useLocation, useNavigate } from "react-router-dom";
import Banner from "@/components/Banner";
import { getFreeDownloadCategory, getFreeDownloadDetail } from "@/api/freeDownload";
import { pxToRem, recursivelyModifyArrayElements } from "@/utils/common";
import useMenusSelect, { findParentIdsOptimized, findFirstLevelCategoryKeys } from "@/hooks/useMenusSelect";
import { Resource } from "@/types/resource";
import HeaderTab from "./component/HeaderTab";
import ResourceOverview from "./component/ResourceOverview";
import ResourceCategory from "./component/ResourceCategory";

const prefix = "freeDownload";

//左侧菜单文件夹图标
const FolderIcon=()=><img src={require('@/assets/images/freedownload/folder.png')} alt="" className={prefix+"-folder"} />;
//菜单缩进图标
const menuIndentIcon=(key:string)=>{
  const indentNum=key.split('-').length-2;
  return <>
    {
      indentNum==1?<FolderIcon/>:<div style={{
        width:pxToRem(14*indentNum),
        height:pxToRem(20),
      }}></div>
    }
  </>
}

function FreeDownload() {
  const navigate = useNavigate();
  const location = useLocation();
  const categoryListRef = useRef<any[]>([]);//分类列表
  const resourceIdRef=useRef<any[]>([null,null,null]);//用于缓存资源id
  const [selectHeaderMenuId, setSelectHeaderMenuId] = useState<number>(-1);
  const selectHeaderMenuIdRef=useRef<number>(-1);//用于缓存selectHeaderMenuId
  const [resourceDetail, setResourceDetail] = useState<Resource.Detail | null>(null);
  const [resourceLoading, setResourceLoading] = useState<boolean>(false);

  const getResourceDetail = useCallback(
    /**
     * 查询资源详情
     * @param id
     */
    (id: string) => {
      setResourceLoading(true);
      setResourceDetail(null);
      getFreeDownloadDetail(id)
        .then((res: any) => {
          console.log("getResourceDetail", res);
          if (res.code == 200) {
            setResourceDetail(res.result);
          } else {
            window.message.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          err?.message && window.message.error(err?.message);
        })
        .finally(() => {
          console.log("finally")
          setResourceLoading(false);
        });
    },
    []
  );

  const menuSelectHandle = useCallback(
    /**
     * 菜单选中处理
     * @param item
     */
    (item: any) => {
      console.log("menuSelectHandle", item);
      if (item.key) {
        navigate(`/freedownload?resourceId=${item.key}`);
      }
    },
    []
  );
  const [menuContext, setMenuContext] = useMenusSelect({
    initConfig: { 
      style: { 
        width: pxToRem(250),
        border:'none' 
      },
      inlineIndent:0,
      className:prefix+"-menu" 
    },
    menuSelectHandle: menuSelectHandle,
  });

  /**
   * 头部导航菜单点击
   * @param id
   */
  const onHeaderMenuClick = useCallback((id: number) => {
    console.log('FreeDownload onHeaderMenuClick',id,resourceIdRef.current);

    if (id == 0) {
      navigate(`/freedownload`);
    } else {
      if(resourceIdRef.current[id]!=null){
        menuSelectHandle({ key: resourceIdRef.current[id] });
      }else{
        changeSelectHeaderMenuId(id);
        firstMenuResourceHandle(id - 1);
      }
      
    }
  }, []);
  const changeSelectHeaderMenuId = useCallback(
    /**
     * 更改选中头部菜单id 
     * @param id 
     */
    (id: number) => {
    setSelectHeaderMenuId(id);
    selectHeaderMenuIdRef.current=id;
  }, []);

  const getCategory = useCallback(
    /**
     * 查询分类列表
     * @returns
     */
    () => {
      return new Promise((resolve, reject) => {
        getFreeDownloadCategory()
          .then((res: any) => {
            console.log("getCategory", res);
            if (res.code == 200) {
              categoryListRef.current = recursivelyModifyArrayElements(res.result, '0',(item: any,key:any) => {
                const category = {
                  meta:item,
                  id: item.id,
                  key: item.id,
                  title: item.name,
                  label: item.name,
                  children: item.children,
                  type: item.type,
                  icon:menuIndentIcon(key)
                };
                if (item.type != "category") {
                  delete category.children;
                }
                return category;
              });
              resolve(true);
            } else {
              reject(false);
            }
          })
          .catch((err) => {
            console.log(err);
            reject(false);
          });
      });
    },
    []
  );

  const firstMenuResourceHandle = useCallback(
    /**
     * 处理首个资源
     * @param newSelectHeaderMenuId
     * @returns
     */
    (newSelectHeaderMenuId: number) => {
      const items = categoryListRef.current?.[newSelectHeaderMenuId]?.children ?? [];
      console.log("firstMenuResourceHandle", items, categoryListRef.current);
      if (items.length == 0) return;
      const menuKeys = findFirstLevelCategoryKeys(items);
      console.log("firstMenuResourceHandle menuKeys", menuKeys);
      if (menuKeys?.selectedKeys.length > 0) {
        //查询首个资源的详情
        menuSelectHandle({ key: menuKeys.selectedKeys[0] });
      }
      const newMenuConfig = {
        items,
        ...menuKeys,
      };
      setMenuContext((prev) => {
        return {
          ...prev,
          ...newMenuConfig,
        };
      });
    },
    []
  );
  const findMenuByResourceId = useCallback(
    /**
     * 根据资源id查找目录结构
     * @param resourceId
     */
    (resourceId: any): [number, any] => {
      const menuList = findParentIdsOptimized(categoryListRef.current, resourceId);
      const headerMenuIndex = categoryListRef.current?.findIndex((item: any) => item.id == menuList[0]);
      const items = categoryListRef.current?.[headerMenuIndex]?.children ?? [];
      const config = {
        items,
        selectedKeys: [resourceId],
        openKeys: menuList.filter((item, index) => index != 0),
      };
      return [headerMenuIndex, config];
    },
    []
  );
  const confirmResource = useCallback(
    /**
     * 获取路由参数 打开对应资源
     */
    () => {
      if (categoryListRef.current?.length == 0) return;
      const searchParams = new URLSearchParams(location.search);
      const resourceId = searchParams.get("resourceId");
      console.log("confirmResource id", resourceId,categoryListRef.current,selectHeaderMenuIdRef.current);
      if (resourceId) {
        if (!menuContext.current.selectedKeys.includes(resourceId) || selectHeaderMenuId == 0) {
          
          //存在资源id 展示对应目录
          const [headerMenuIndex, config] = findMenuByResourceId(resourceId);
          changeSelectHeaderMenuId(headerMenuIndex + 1);
          setMenuContext((prev) => {
            return {
              ...prev,
              ...config,
            };
          });
        }
        getResourceDetail(resourceId);
      } else {
        //没有参数 展示第一个资源
        // onHeaderMenuClick(1);
        changeSelectHeaderMenuId(0);
        setResourceLoading(false);
      }

      if(resourceId){
        resourceIdRef.current[selectHeaderMenuIdRef.current] = resourceId;
      }
      
    },
    [location, selectHeaderMenuId]
  );

  useEffect(() => {
    console.log("FreeDownload location", location);
    confirmResource();
  }, [location]);
  const init = async () => {
    try {
      const res = await getCategory();
      console.log("getCategory res", res);
      if (res) {
        confirmResource();
      }
    } catch (error) {
      console.log(error);
      window.message.error("服务器异常");
    }
  };

  useEffect(() => {
    init();
  }, []);
  return (
    <div className={prefix}>
      <iframe id="hm_iframe" style={{ display: "none" }} src=""></iframe>

      <Banner pageKey={"freedownload"} />

      <Spin spinning={resourceLoading}>
        <main>
          <div className={prefix + "-content"}>
            {categoryListRef.current?.length > 0 && (
              <HeaderTab
                tabs={[
                  {
                    id: 0,
                    key: 0,
                    title: "概览",
                    label: "概览",
                  },
                  ...categoryListRef.current,
                ]}
                activeId={selectHeaderMenuId}
                onHeaderMenuClick={onHeaderMenuClick}
              />
            )}
            {selectHeaderMenuId < 0 ? null : selectHeaderMenuId == 0 ? (
              <ResourceOverview menu={categoryListRef.current} />
            ) : (
              <ResourceCategory
                menuContext={menuContext.current}
                resourceDetail={resourceDetail}
                resourceLoading={resourceLoading}
              />
            )}
          </div>
        </main>
      </Spin>
    </div>
  );
}

export default FreeDownload;
